import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import ChatMessage from '../../shared/chatMessage'
import { Claims } from '../../../utils/services/cache/ClientCache'

const MonsterMessages = ({ _open, _handleClose, _iconUrl, _messages }) => {

    const infoAlert = (message) => {
        let content = `<div class="adventurelearnPaper-root adventurelearnAlert-root adventurelearnAlert-standardInfo">
<div class="adventurelearnAlert-icon">
<svg class="adventurelearnSvgIcon-root adventurelearnSvgIcon-fontSizeInherit" viewBox="0 0 24 24">
<path d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"></path>
</svg>
</div>
<div class="adventurelearnAlert-message">${message}</div>
</div>`
        return content;
    }

    const greetingAlert = (message) => {
        let content = `<div class="adventurelearnPaper-root adventurelearnAlert-root adventurelearnAlert-standardGreet">
<div class="adventurelearnAlert-message">${message}</div>
</div>`
        return content;
    }

    const notiAlert = (message) => {
        let content = `<div class="adventurelearnPaper-root adventurelearnAlert-root">
<div class="adventurelearnAlert-message">${message}</div>
</div>`
        return content;
    }

    let contents = [];
    _messages.forEach((item) => {
        let content = notiAlert(item);
        contents.push(content);
    });

    return (
        <div>
            <Dialog
                fullWidth={true}
                maxWidth={'md'}
                open={_open}
                onClose={_handleClose}
                scroll={'paper'}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description">
                <DialogTitle id="scroll-dialog-title">Messages</DialogTitle>
                <DialogContent dividers={true}>

                    <div>
                        <ChatMessage
                            avatar={_iconUrl}
                            messages={[
                                infoAlert('Please feed me food to increase my level and mood'),
                                infoAlert('Food will be on the island if available'),
                                infoAlert('Alternatively, please do some recommended learning contents to increase mood!'),
                            ]}
                        />
                        <ChatMessage
                            avatar={_iconUrl}
                            messages={[
                                greetingAlert(`Hi ${Claims.getGivenName()}, Have a wonderful day ahead.`),
                                greetingAlert('It is my pleasure to help you.'),
                            ]}
                        />
                        <ChatMessage avatar={_iconUrl}
                            messages={contents} />
                    </div>

                </DialogContent>
                <DialogActions>
                    <Button onClick={_handleClose}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export { MonsterMessages as default }